<template>
  <div>
    <slot v-if="w != null" v-bind:width="w"></slot>
  </div>
</template>

<script>
export default {
  name: 'auto-width',

  data () {
    return {
      w: null
    }
  },

  mounted() {
    this.w = this.$el.clientWidth;
    this.o = new ResizeObserver(this.onResize);
    this.o.observe(this.$el);
  },

  beforeDestroy() {
    this.o.unobserve(this.$el);
  },

  methods: {
    async onResize() {
      await this.$nextTick();
      this.w = this.$el.clientWidth;
    }
  },

  watch: {
    w(w) {
      // It is possible to get into an infinite loop here where measuring the width triggers an action that causes the
      // slotted component to change, thus forcing a re-evaluation. This is rare, but can happen when the browser adds
      // a scroll bar to overflowing content.
      if (!this.updates)
        this.updates = [];
      if ((this.updates.length < 2) || (this.updates[this.updates.length - 2] != w)) {
        this.updates.push(w);
        this.$emit('update', w);
      }
    }
  }

}
</script>
